import React from 'react';
import PT from 'prop-types';
import * as LoaderComponent from 'react-loaders';
// eslint-disable-next-line import/no-webpack-loader-syntax
import '!style-loader!css-loader!loaders.css/loaders.min.css';
import './Loader.scss';

const Loader = ({ className, fullScreen, ...props }) => (
	<LoaderComponent.Loader
		type="ball-scale-ripple-multiple"
		{...props}
		className={`${className} ${fullScreen ? 'full-screen' : ''}`}
	/>
);

Loader.defaultProps = {
	type: 'ball-scale-ripple-multiple',
	active: false,
	fullScreen: false,
	color: '',
	className: '',
	innerClassName: '', // applied to the same div as .loader-inner.${type}
	// useful for advanced styling
	// className & style are implied
};

Loader.propTypes = {
	type: PT.string,
	active: PT.bool,
	fullScreen: PT.bool,
	color: PT.string,
	className: PT.string,
	innerClassName: PT.string, // applied to the same div as .loader-inner.${type}
	// useful for advanced styling
	// className & style are implied
};

export default Loader;
